<template>
  <exception-page type="403" />
</template>

<script>
import ExceptionPage from '../exception-page'

export default {
  components: {
    ExceptionPage
  }
}
</script>

<style scoped>

</style>
